var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 22,
  viewBox: "0 0 21 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 5.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.498 12.546C5.034 10.974 7.155 10 9.5 10s4.466.974 6.002 2.546A8.8 8.8 0 0 1 18 18.72V21H1v-2.28c0-2.41.953-4.594 2.498-6.174Z"
}))));
export default SvgAvatar;